import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.13171 5.95604C8.50117 5.54553 9.13346 5.51226 9.54397 5.88171L13.294 9.25671C13.5047 9.44636 13.625 9.71652 13.625 10C13.625 10.2835 13.5047 10.5537 13.294 10.7433L9.54397 14.1183C9.13346 14.4878 8.50117 14.4545 8.13171 14.044C7.76226 13.6335 7.79553 13.0012 8.20604 12.6317L11.1302 10L8.20604 7.3683C7.79553 6.99884 7.76226 6.36655 8.13171 5.95604Z"
    }, null, -1)
  ])))
}
export default { render: render }